import { TopBar } from '@atlassian/navigation-system';
import { SideNavToggleButton } from '@atlassian/navigation-system/v4';
import { CommonActions, HomeActions, UserActions } from '@atlassian/navigation-system/v4';
import React from 'react';

import { AppSwitcherButton, ProfileAndWorkspaceSwitcherButton } from '@townsquare/navigation';
import { HelpPanel } from '@townsquare/navigation/help';
import { NewButton } from '@townsquare/navigation/new-button';
import { NotificationsBell } from '@townsquare/navigation/notifications';
import { SettingsPopup } from '@townsquare/navigation/settings-home';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { ProductHome } from '../navigation/ProductHome';

import { SearchDialog } from './GriffinTopSearch';

export const GriffinTopNavigation = () => {
  const noWorkspaceExperience = useNoWorkspaceExperience();

  return (
    <TopBar>
      <HomeActions>
        <SideNavToggleButton />
        <AppSwitcherButton />
        <ProductHome />
      </HomeActions>
      {!noWorkspaceExperience && (
        <CommonActions>
          <SearchDialog />
          <NewButton />
        </CommonActions>
      )}
      <UserActions>
        <HelpPanel isMobileWidth={false} />
        <NotificationsBell />
        <SettingsPopup />
        <ProfileAndWorkspaceSwitcherButton />
      </UserActions>
    </TopBar>
  );
};
